module.exports = __webpack_public_path__ + "static/18-472f4b69e06e0e9895cbc3ac48b86c16.jpg";